import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Grupy użytkowników — etykieta organizacyjna wyświetlana na liście użytkowników (bez uprawnień).
// Zarządzanie wymaga ROLE_28, samą listę grup pobiera także ROLE_7 (formularze użytkownika).
class UserGroupsService {
  async getAll() {
    const response = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/user-groups`);

    return Array.isArray(response) ? response : [];
  }

  async add(name, description = '', userIds = []) {
    if (!name || String(name).trim() === '') {
      throw new Error('Group name is required.');
    }

    return fetchWrapper.post(`${process.env.VUE_APP_API_URL}/user-groups`, {
      name: String(name).trim(),
      description: description ?? '',
      userIds: Array.isArray(userIds) ? userIds : [],
    });
  }

  // Pominięte (null) pole = bez zmian; `userIds` to pełny, nowy skład grupy.
  async update(id, name = null, description = null, userIds = null) {
    const body = {};

    if (name !== null) {
      body.name = String(name).trim();
    }
    if (description !== null) {
      body.description = description;
    }
    if (userIds !== null) {
      body.userIds = Array.isArray(userIds) ? userIds : [];
    }

    return fetchWrapper.put(`${process.env.VUE_APP_API_URL}/user-groups/${id}`, body);
  }

  async delete(id) {
    return fetchWrapper.delete(`${process.env.VUE_APP_API_URL}/user-groups/${id}`);
  }

  // Użytkownicy, których można przypisać do grupy (ROLE_28 — bez dostępu do pełnego /users).
  async getAssignableUsers() {
    const response = await fetchWrapper.get(`${process.env.VUE_APP_API_URL}/user-groups/assignable-users`);

    return Array.isArray(response) ? response : [];
  }
}

export default new UserGroupsService();
